import { isWebAlert } from '@m2h/common/constants';
import { getLanguage } from '@m2h/common/utils';
import { initXxhashWithFallback } from '@m2h/common/utils/hasher';
import './mainIndex';
import RuntimeLocaleProvider, {
  syncDocumentLocale,
} from '@m2h/common/i18n/RuntimeLocaleProvider';
import { initHistory } from '@m2h/common/utils/history';
import { sendParentCloseIframe } from '@m2h/common/utils/iframe';
import { initRegionConfigs, setCurrentLocation } from '@m2h/common/utils/location';
import { init } from '@m2h/common/utils/postMsg';
import { fetchAbStrategy, getComStrategys } from '@m2h/common/webApi/abStrategy';
import { getPassportUserInfo } from '@m2h/common/webApi/passport';
import React, { useCallback, useEffect } from 'react';
import '@m2h/common/Mach/machproH5Base/native-worker';
import { createRoot } from 'react-dom/client';
import { debounce } from 'lodash';
import Router from './router';

const resizePath = [
  '/mpweb',
  '/mpweb/home_page_main',
  '/mpweb/pick_up_page_main',
  '/mpweb/meal_for_one_main',
  '/mpweb/channel_list_main',
  '/mpweb/order_list',
  '/mpweb/mine',
];
/**
 * 屏幕尺寸适配组件
 * 监听浏览器窗口尺寸变化,自动更新 Mach.env 中的屏幕尺寸信息
 */
const ScreenSizeAdapter = () => {
  /**
   * 更新 Mach.env 中的屏幕尺寸信息
   */
  const updateScreenSize = useCallback((e) => {
    if (e.target === window && resizePath.includes(window.location.pathname)) {
      console.log('[ScreenSizeAdapter] Window resize listener detached', e);
      window.location.reload();
    }
    // console.log('[ScreenSizeAdapter] Window resize listener eeeeeee', e);
    // 使用 href 重新导航，保持单页应用状态
    // const currentUrl = window.location.href;
    // // 添加时间戳避免浏览器缓存
    // const url = new URL(currentUrl);
    // url.searchParams.set('_t', Date.now().toString());
    // window.location.href = url.toString();
  }, []);

  /**
   * 防抖后的更新函数
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedUpdateScreenSize = useCallback(
    debounce(updateScreenSize, 500),
    [updateScreenSize]
  );

  useEffect(() => {
    // 监听窗口尺寸变化
    window.addEventListener('resize', debouncedUpdateScreenSize);

    // 清理函数:移除事件监听器
    return () => {
      window.removeEventListener('resize', debouncedUpdateScreenSize);
      console.log('[ScreenSizeAdapter] Window resize listener detached');
    };
  }, [debouncedUpdateScreenSize, updateScreenSize]);

  return null;
};

// ----- mpweb适配origin -----
// await initXxhashWithFallback();
// ----- mpweb适配change -----
// Native SLLocation 权限状态同步权威；浏览器权限异步收敛，
// 在 createRoot().render() 与首个 React.lazy 页面 chunk 加载前完成一次权限初始化，
// 此后所有业务（含 SPA 路由、同源 iframe 复用 top 模块）同步读取同一快照。
// allSettled：必须等两个初始化都真正 settle 才放行，任一 reject 不阻断渲染（不白屏），
// 初始化自身也兜底为永不向上 reject。
await Promise.allSettled([
  // wasm-hash初始化
  initXxhashWithFallback(),
  Mach.requireModule('SLLocation')?.initializeAuthorizationStatus?.(),
]);
// ----- mpweb适配       -----

if (isWebAlert) {
  console.log('mpwebAlert');
  document.body.className = 'iframe-body';

  // document.body.addEventListener('click', sendParentCloseIframe);
  // ----- mpweb适配origin -----
  // Mach.on('close', sendParentCloseIframe);
  // ----- mpweb适配change -----
  // persist：入口级监听需跨路由存活，跳过路由切换时的自动清理。
  Mach.on('close', sendParentCloseIframe, { persist: true });
  // ----- mpweb适配       -----
  // window.addEventListener('beforeunload', (event) => {
  //   Mach.off('close', sendParentCloseIframe);
  //   // document.body.removeEventListener('click', sendParentCloseIframe);
  // });
} else {
  console.log('mpwebAlert init');
  init();
  initHistory();
}

// 调用时，没有值，则会自动接口拉取，已有值，则异步3秒后拉取更新
if (getComStrategys()?.length) {
  setTimeout(() => fetchAbStrategy(), 3100);
}
// 单页应用切路由不会执行到
getPassportUserInfo();
setCurrentLocation();
initRegionConfigs();

// initIframe();
// setTimeout(() => {
// initIframe();
// 预加载逻辑
// 首页预加载地址弹窗页
// 提单预加载优惠券页
// const pathName = '/mpweb/address_select_popup';
// const url = `${window.location.origin}${pathName}?mpwebAlert=1`;
// preOpenAlertIframe({ url }); // Mach环境变量会被设置为iframe bundle的，需要env/data全面by url隔离才能启用
// }, 3100);

const initialLocale = getLanguage();
syncDocumentLocale(initialLocale);

const container = document.getElementById('root') as HTMLElement;
createRoot(container).render(
  <RuntimeLocaleProvider initialLocale={initialLocale}>
    <ScreenSizeAdapter />
    {<Router /> as React.ReactNode}
  </RuntimeLocaleProvider>
);
